import React, { useRef, useMemo } from 'react';

export const useLocationRefs = memoizedLocations => {
  const locationsWrapperRef = useRef(null);
  const locationsRefs = useMemo(() => {
    return memoizedLocations.reduce((acc, location) => {
      acc[location.id] = React.createRef();
      return acc;
    }, {});
  }, [memoizedLocations]);

  return { locationsWrapperRef, locationsRefs };
};
